import {gql} from '@apollo/client';

export const GENERATIVE_PREDICTION_JOBS_QUERY = gql`
  query GenerativePredictionJobsQuery($proteinId: StrictString, $moleculeId: StrictString)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    generativePredictionJobs(proteinId: $proteinId, moleculeId: $moleculeId) {
      id
      statusCode
      createdAt
    }
  }
`;

export const GENERATIVE_PREDICTION_JOB_DETAIL_QUERY = gql`
  query GenerativePredictionJobDetailQuery($id: StrictString!) @skipAudit @engComponent(name: MODEL_HUB) {
    predictionJob(id: $id) {
      id
      standardizedOutputDownloadUrl
      resultsDownloadUrl
    }
  }
`;
